import React from "react";
import "./KaranatakaHrdUniversities.css";

const countries = [
  "BANGALORE UNIVERSITY HRD",
  "CHRIST UNIVERSITY HRD",
  "NORTH  BANGALORE UNIVERSITY v",
  "BANGALORE CITY UNIVERSITY HRD",
  "KRISTA JYOTHI BANGALORE UNIVERSITY HRD",
  "CMR  UNIVERSITY HRD",
  "JAIN  UNIVERSITY HRD",
  "RAMAIAH  UNIVERSITY HRD",
  "Indian Institute of Science (IISc) HRD",
  "PES UNIVERSITY HRD",
  "RV UNIVERSITY HRD",
  "DAYANAND SAGAR UNIVERSITY HRD",
  "PRESIDENCY UNIVERSITY HRD",
  "ST JOSEPH UNIVERSITY HRD",
  "RGUHS CERTIFICATE HRD ",
  "University of Agricultural Sciences Bangalore HRD",
  "PUC CERTIFICATE HRD",
  "DIPLOMA TECHNICAL BOARD HRD",
  "NURSING CERTIFICATE HRD",
  "PARAMEDICAL CERTIFICATE HRD",
  "NURSING CERTIFICATE HRD",
  "ITI CERTIFICATE HRD",
  "DENTAL CERTIFICATE HRD",
  "MYSORE UNIVERSITY HRD",
  "MANAGALORE UNIVERSITY HRD",
  "NTTF CERTIFICATE HRD",
  "TUMKUR UNIVERSITY HRD",
  "ADI CHUNCHANAGIRI UNIVERSITY HRD",
  "SIDDAGANGA UNIVERSITY HRD",
  "SITHARTH UNIVERSITY HRD",
  "RAJIV GANDHI UNIVERSITY HEALTH AND SCIENCE HRD",
  "KARNATAKA MEDICAL COUNCIL HRD",
  "AZIM PREMJI UNIVERSITY vHRD",
  "MANIPAL UNIVERSITY HRD",
  "VISVESWARAYA TECHNICAL UNIVERSITY HRD",
  "DAVANAGERE UNIVERSITY HRD",
  "GARDEN CITY UNIVERSITY HRD",
];

const KaranatakaHrdUniversities = () => {
  return (
    <div className="KaranatakaHrdUniversities-container" id="europeCountryList">
      {/* <h2 className="acl-title">
        {" "}
        List of <span>Hague Convention Countries</span>
      </h2> */}
      <ul className="acl-list">
        {countries.map((country, index) => (
          <li key={index} className="acl-item">
            {country}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default KaranatakaHrdUniversities;
